import { render, staticRenderFns } from "./QRCodeVolunteer.vue?vue&type=template&id=0613be72&scoped=true"
import script from "./QRCodeVolunteer.vue?vue&type=script&lang=js"
export * from "./QRCodeVolunteer.vue?vue&type=script&lang=js"
import style0 from "./QRCodeVolunteer.vue?vue&type=style&index=0&id=0613be72&prod&lang=less&scoped=true"
import style1 from "./QRCodeVolunteer.vue?vue&type=style&index=1&id=0613be72&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0613be72",
  null
  
)

export default component.exports